import React from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import Step from '../../../../../../features/components/Forms/StepForm/Step'

import { NAME } from '../fields'

function NameStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const stepFields = [NAME]

  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <Step stepTitle={t('Enter Ad Name')} handleContinue={handleContinue}>
      <Field formik={formik} name={NAME} placeholder={t('Ad Name')} autoComplete="off" />
    </Step>
  )
}

export default NameStep
